/**
 * Abspielen von Animationen bei Erfüllen von Bedingungen
 * @class service_v3sConditionService
 * @memberOf v3sWbtPlayerApp:animation
 */
angular.module('v3sWbtPlayerApp').factory('v3sConditionService', ["v3sTimelineService", "v3sNavigationService", function (v3sTimelineService, v3sNavigationService) {

    var actions;

    var v3sConditionAction = function (data) {
        this.items = [];
        this.actions = [];
        this.conditions = [];

        if (!!data && !!data.items && !!data.actions && !!data.conditions) {

            var itemIds = data.items.split(";");
            var items = this.items;

            angular.forEach(itemIds, function (itemId) {
                var item = v3sNavigationService.getItem(itemId);
                if (!!item) {
                    items.push(item);
                }
            });

            if (this.items.length > 0) {
                this.conditions = data.conditions.split(";");
                this.actions = data.actions;
            }
        }
    };

    v3sConditionAction.prototype.isConditionMet = function () {

        for (var i = 0; i < this.items.length; i++) {
            var item = this.items[i];

            for (var j = 0; j < this.conditions.length; j++) {
                var condition = this.conditions[j];


                if (condition == "completed" && !item.isCompleted()) {
                    return false;
                }

                if (condition == "incomplete" && item.isCompleted()) {
                    return false;
                }

                if (condition == "passed" && (!item.isPassed() || !item.isEvaluated())) {
                    return false;
                }

                if (condition == "failed" && (item.isPassed() || !item.isEvaluated())) {
                    return false;
                }

                if (condition == "lastPassed" && (!item.isLastPassed() || !item.isLastEvaluated())) {
                    return false;
                }

                if (condition == "lastFailed" && (item.isLastPassed() || !item.isLastEvaluated())) {
                    return false;
                }

                if (condition == "incompleteOrFailed" && item.isCompleted() && (item.isPassed() || !item.isEvaluated())) {
                    return false;
                }

                if (condition == "locked" && !item.isLocked()) {
                    return false;
                }

                if (condition == "unlocked" && item.isLocked()) {
                    return false;
                }

                if (condition == "trackable" && !item.isTrackable()) {
                    return false;
                }

                if (condition == "notTrackable" && item.isTrackable()) {
                    return false;
                }


                if (condition.indexOf("score=") >= 0) {
                    var scores = condition.split(":");

                    var minScore = parseInt(scores[0].replace("score=", ""));
                    var maxScore = parseInt(scores[1]) || minScore;

                    if (minScore >= 0 && maxScore <= 100) {
                        if (item.getScore() < minScore || item.getScore() > maxScore) {
                            return false;
                        }
                    }
                }

                if (condition.indexOf("lastScore=") >= 0 && !!item.getLastScore) {
                    var scores = condition.split(":");

                    var minScore = parseInt(scores[0].replace("lastScore=", ""));
                    var maxScore = parseInt(scores[1]) || minScore;

                    if (minScore >= 0 && maxScore <= 100) {
                        if (item.getLastScore() < minScore || item.getLastScore() > maxScore) {
                            return false;
                        }
                    }
                }

                if (condition.indexOf("attempt=") >= 0 && !!item.getAttempt) {
                    var attempts = condition.split(":");

                    var minAttempt = parseInt(attempts[0].replace("attempt=", ""));
                    var maxAttempt = parseInt(attempts[1]) || minAttempt;

                    if (minAttempt >= 0) {
                        var attempt = item.getAttempt();
                        if (attempt < minAttempt || attempt > maxAttempt) {
                            return false;
                        }
                    }
                }
            }
        }

        return true;
    };

    v3sConditionAction.prototype.playActions = function () {
        angular.forEach(this.actions, function (action) {
            v3sTimelineService.addAsyncAction(action);
        });
    };


    /**
   * Initialisiert die Interaktionen
   * @memberOf v3sWbtPlayerApp:animation.service_v3sConditionService
   */
    function init(pScope) {
        actions = [];

        pScope.currentPage.subscribePageChanged(pScope, function () {
            playActions();
        });
    }

    /**
   * Spielt Aktionen mit Bedingungen ab
   * @memberOf v3sWbtPlayerApp:animation.service_v3sConditionService
   */
    function playActions() {
        var i = 0;
        while (!!actions && i < actions.length) {
            if (actions[i].isConditionMet()) {
                actions[i].playActions();
                actions.splice(i, 1);
            } else {
                i++;
            }
        }
    }

    /**
     * Fügt eine Reihe von Animation mit Bedingungen hinzu.
     * @param {object} period - Daten mit Aktionen
     * @memberOf v3sWbtPlayerApp:animation.service_v3sConditionService
     */
    function addPeriod(period) {
        var action = new v3sConditionAction(period);

        if (action.isConditionMet()) {
            action.playActions();
        } else {
            actions.push(action);
        }
    }

    /**
    * Stoppt alle Animationen und räumt auf
    * @memberOf v3sWbtPlayerApp:animation.service_v3sConditionService
    */
    function destroy() {
        actions = null;
    }

    return {
        init: init,
        addPeriod: addPeriod,
        destroy: destroy
    };

}]);
